import React, { useContext, useEffect, useMemo, useState } from 'react';
import { withStyles } from '@material-ui/styles';
import SelfInspectQuestionLabel from '../SelfInspectQuestionLabel';
import { QUICK_VUE_IMAGES } from '../../../pages/self-inspect/quickVueConfig';
import { getComponentToRender } from '../../../pages/self-inspect/quickVueUtils';
import DeleteIcon from '@material-ui/icons/Delete';
import { Dialog, DialogContent, Button as MuiButton } from '@material-ui/core';
import Loading from '../../Loading';
import FarmOutbuildingsReview from './FarmOutbuildingsReview';
import { AppContext } from '../../../AppContext';
import SelfInspectButton from '../SelfInspectButton';

const styles = theme => ({
  container: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  scrollContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    overflow: 'inherit',
  },

  supportNumber: {
    flexGrow: 0,
    flexBasis: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },

  imagePreviewContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'relative',
  },

  actionContainer: {
    flexGrow: 0,
    flexBasis: 'auto',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 5,
    paddingBottom: 5,
  },
  image: {
    maxHeight: '80%',
    maxWidth: '100%',

    borderRadius: 5,
    padding: '20px 30px',
    background: '#00000022',
  },

  questionLabel: {
    fontSize: '2rem',
    textAlign: 'center',
    fontWeight: 'bold',
    marginBottom: 10,
  },

  questionLabel2: {
    fontSize: '2rem',
    textAlign: 'center',
    fontWeight: 'bold',
    marginBottom: 20,
  },

  questionLabel3: {
    fontSize: '1rem',
    textAlign: 'center',
    fontWeight: 'bold',
    marginBottom: 20,
  },

  imageHeaderContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },

  answerContainerOuter: {
    width: '100%',
    flex: 1,
    fontSize: '1.25rem',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    marginTop: 10,
  },

  removeImageIcon: {
    color: 'var(--jmi-red)',
    fontSize: 30,
    marginLeft: 30,
  },
});

const IMAGE_UPLOAD_INPUT_ID = 'image-capture';

const BOTTOM_PANEL_TRANSITION = '0.5s all ease-in-out';

export const OUTBUILDING_STEPS_TEMPLATE = [
  {
    cardNumber: null,
    outbuildingNumber: null,
    allowResume: true,
    type: 'image-radios',
    title: 'Structure Type',
    disableContinueIfNoAnswer: true,

    questionId: 7244,
    options: [
      /**
       *
       * * NOT IN THIS LIST
       * chicken coop
       * greenhouse
       *
       *
       * * NOT IN ANSWER_VALUE
       * Carport
       * Carriage House
       * Mobile Home
       *
       *
       * * ACCOUNTED FOR
       * Other
       * Barn
       * Carport
       * Pole Building
       * Shed
       * Garage
       * Carriage House
       * Grain Bin
       * Implement Shed
       * Lean To
       * Livestock Confinement Building
       * Mobile Home
       * Silo
       * Utility Building
       */

      { value: 12, label: 'Other', image: QUICK_VUE_IMAGES.BARN },
      { value: 48, label: 'Barn', image: QUICK_VUE_IMAGES.BARN },
      // { value: 60, label: 'Carport', image: QUICK_VUE_IMAGES.BARN },
      { value: 135, label: 'Pole Building', image: QUICK_VUE_IMAGES.BARN },
      { value: 152, label: 'Shed', image: QUICK_VUE_IMAGES.BARN },
      { value: 1120, label: 'Garage', image: QUICK_VUE_IMAGES.BARN },
      // { value: 2085, label: 'Carriage House', image: QUICK_VUE_IMAGES.BARN },
      { value: 2092, label: 'Grain Bin', image: QUICK_VUE_IMAGES.BARN },
      { value: 2093, label: 'Implement Shed', image: QUICK_VUE_IMAGES.BARN },
      { value: 2095, label: 'Lean To', image: QUICK_VUE_IMAGES.BARN },
      { value: 2096, label: 'Livestock Confinement', image: QUICK_VUE_IMAGES.BARN },
      // { value: 2099, label: 'Mobile Home', image: QUICK_VUE_IMAGES.BARN },
      { value: 2108, label: 'Silo', image: QUICK_VUE_IMAGES.BARN },
      { value: 2112, label: 'Utility Building', image: QUICK_VUE_IMAGES.BARN },

      { value: 11340, label: 'Chicken coop', image: QUICK_VUE_IMAGES.BARN },
      { value: 92, label: 'Greenhouse', image: QUICK_VUE_IMAGES.BARN },
    ].sort((a, b) => a.label.localeCompare(b.label)),
  },

  {
    cardNumber: null,
    outbuildingNumber: null,
    allowResume: true,
    questionId: 2122,
    type: 'textarea',
    inputType: 'textarea',
    questionLabel: 'Description',
    answerValue: null,
  },

  {
    cardNumber: null,
    outbuildingNumber: null,
    allowResume: true,
    questionId: 7245,
    type: 'take-picture',
    questionImage: QUICK_VUE_IMAGES.HOUSE_FRONT_LEFT,
    questionLabel: `Let's get a corner picture that shows the FRONT and SIDE of your house!`,
    answerValue: null,
    shortLabel: 'Front & side',
  },

  {
    cardNumber: null,
    outbuildingNumber: null,
    allowResume: true,
    questionId: 7246,
    type: 'take-picture',
    questionImage: QUICK_VUE_IMAGES.HOUSE_REAR_RIGHT,
    questionLabel: `Now we need one that shows the OPPOSITE SIDE and BACK of the house!`,
    answerValue: null,
    shortLabel: 'Back and side',
  },
];

const FarmOutbuildingsCard = withStyles(styles)(props => {
  const {
    // form values
    cardNumber,
    questionId,
    questionImage,
    title,
    questionLabel,
    questionLabel2,
    questionLabel3,
    shortLabel,
    answerValue,
    hideDevButton,
    navLabelOverride,
    multiple,
    //
    // functions
    updateAnswer,
    resetAnswer,
    confirmAnswer,
    deleteImage,
    //
    // other
    isActive,
    isBefore,
    isAfter,
    classes,
    selfInspectIntro,
    stepIndex,
    pendingSaves,
    goBack,
    hideBackButton,
    addAdditionalOutbuilding,
    removeOutbuilding,

    outbuildingSteps,
  } = props;

  // #region STATE
  const [currentOutbuildingStepIndex, setCurrentOutbuildingStepIndex] = useState(-1);
  const [addingOutbuilding, setAddingOutbuilding] = useState(false);
  const [removingOutbuilding, setRemovingOutbuilding] = useState(false);
  const [showConfirmOutbuildingRemoval, setShowConfirmOutbuildingRemoval] = useState(false);
  const [autoNavigateToOutbuildingNumber, setAutoNavigateToOutbuildingNumber] = useState(-1);
  const [showReview, setShowReview] = useState(false);
  const [showNoOutbuildingsError, setShowNoOutbuildingsError] = useState(false);
  // #endregion STATE

  // #region HOOKS
  const { dispatch } = useContext(AppContext);
  // #endregion HOOKS

  // #region COMPUTED
  const showAdditionalStructuresQuestion = currentOutbuildingStepIndex === -1 && !showReview;

  const currentOutbuildingStep =
    showAdditionalStructuresQuestion || showReview ? null : outbuildingSteps[currentOutbuildingStepIndex];

  const InputComponent = useMemo(() => {
    if (!isActive || currentOutbuildingStepIndex === -1 || !currentOutbuildingStep) {
      return null;
    }

    const { type } = currentOutbuildingStep;
    const component = getComponentToRender(type);

    return component;
  }, [isActive, currentOutbuildingStepIndex]);

  const outbuildingNumbers = [...new Set(outbuildingSteps.map(ob => ob.outbuildingNumber))];
  const totalOutbuildings = outbuildingNumbers.length;
  const outbuildingOptions = outbuildingNumbers.map((obNumber, i) => ({
    value: obNumber,
    label: i + 1,
  }));

  const selectedOutbuildingNumber = currentOutbuildingStep?.outbuildingNumber;
  const selectedOutbuildingOption = outbuildingOptions.find(ob => ob.value === selectedOutbuildingNumber);

  const currentOutbuildingIndex = outbuildingNumbers.findIndex(ob => ob === selectedOutbuildingNumber);
  const isFirstOutbuilding = currentOutbuildingIndex === 0;
  const isLastOutbuilding = currentOutbuildingIndex === outbuildingNumbers.length - 1;

  // #endregion COMPUTED

  // #region FUNCTIONS
  const goBackOverride = () => {
    if (showReview) {
      goBack();
      return;
    }

    const firstStepIndexForCurrentOutbuilding = outbuildingSteps.findIndex(
      os => os.outbuildingNumber === selectedOutbuildingNumber,
    );

    const isFirstSubStep = firstStepIndexForCurrentOutbuilding === currentOutbuildingStepIndex;

    if (isFirstSubStep) {
      setCurrentOutbuildingStepIndex(-1);
      setShowReview(true);
    } else {
      setCurrentOutbuildingStepIndex(prev => prev - 1);
    }
  };

  const handleGoToReview = () => {
    // save answer before navigating away
    confirmAnswer({ ...currentOutbuildingStep, isOutbuildingStep: true });

    setShowReview(true);
    setCurrentOutbuildingStepIndex(-1);
  };

  const updateAnswerOverride = params =>
    props.updateAnswer({
      ...params,

      isOutbuildingStep: true,
    });

  const confirmAnswerOverride = params => {
    props.confirmAnswer({ ...params, isOutbuildingStep: true });

    const lastStepIndexForCurrentOutbuilding =
      outbuildingSteps.length -
      1 -
      outbuildingSteps
        .slice()
        .reverse()
        .findIndex(os => os.outbuildingNumber === selectedOutbuildingNumber);

    const isLastSubStep = lastStepIndexForCurrentOutbuilding === currentOutbuildingStepIndex;

    if (isLastSubStep) {
      setCurrentOutbuildingStepIndex(-1);
      setShowReview(true);
    } else {
      setCurrentOutbuildingStepIndex(currentOutbuildingStepIndex + 1);
    }

    // const isLastStep = currentOutbuildingStepIndex === outbuildingSteps.length - 1;

    // if (isLastStep) {
    //   setCurrentOutbuildingStepIndex(-1);
    //   setShowReview(true);
    // } else {
    //   setCurrentOutbuildingStepIndex(currentOutbuildingStepIndex + 1);
    // }
  };

  const deleteImageOverride = formImageId => {
    const currentOutbuildingOrderFormHeaderId = currentOutbuildingStep?.orderFormHeaderId;
    props.deleteImage(formImageId, currentOutbuildingOrderFormHeaderId);
  };

  const viewOutbuilding = outbuildingNumber => {
    setAutoNavigateToOutbuildingNumber(outbuildingNumber);
    setShowReview(false);
  };

  const handleAdditionalStructureYes = async () => {
    /**
     * 1. store last outbuilding card index
     * 2. add new outbuilding
     * 3. set current outbuilding index to new outbuilding
     */

    setAddingOutbuilding(true);
    await addAdditionalOutbuilding();
    setAddingOutbuilding(false);
    setShowNoOutbuildingsError(true);

    // setCurrentOutbuildingStepIndex(lastOutbuildingIndex + 1);

    dispatch({
      type: 'SET_SNACKBAR',
      snackbar: {
        isOpen: true,
        variant: 'success',
        message: `Created Structure #${totalOutbuildings + 1}`,
      },
    });
  };

  const handleAdditionalStructureNo = () => {
    confirmAnswer({
      cardNumber,
    });
  };

  // const completeIntro = () => {

  //   if (outbuildingSteps.length) {
  //     setCurrentOutbuildingStepIndex(0);
  //   } else {
  //     setShowReview(true);
  //   }
  // };

  const cancelRemoveOutbuilding = () => {
    setShowConfirmOutbuildingRemoval(false);
  };

  const confirmRemoveOutbuilding = async () => {
    setRemovingOutbuilding(true);

    // const isLastStep = currentOutbuildingStepIndex === outbuildingSteps.length - 1;
    const isLastOutbuilding =
      currentOutbuildingStep.outbuildingNumber === outbuildingSteps.slice(-1)[0].outbuildingNumber;
    const isOnlyOutbuilding = outbuildingSteps.length === 1;

    const outbuildingNumbers = [...new Set(outbuildingSteps.map(ob => ob.outbuildingNumber))];

    const currentOutbuildingOrderFormHeaderId = currentOutbuildingStep?.orderFormHeaderId;
    const currentOutbuildingNumber = currentOutbuildingStep?.outbuildingNumber;

    const success = await removeOutbuilding(currentOutbuildingOrderFormHeaderId);

    setRemovingOutbuilding(false);

    if (!success) {
      return;
    }

    if (isOnlyOutbuilding) {
      setCurrentOutbuildingStepIndex(-1);
      return;
    }

    const currentOutbuildingNumberIndex = outbuildingNumbers.findIndex(ob => ob === currentOutbuildingNumber);
    const goToOutbuildingNumber = isLastOutbuilding
      ? outbuildingNumbers[currentOutbuildingNumberIndex - 1]
      : outbuildingNumbers[currentOutbuildingNumberIndex + 1];

    setAutoNavigateToOutbuildingNumber(goToOutbuildingNumber);
  };

  const goToPreviousStructure = () => {
    if (isFirstOutbuilding) return;

    const currentOutbuildingNumberIndex = outbuildingNumbers.findIndex(
      ob => ob === currentOutbuildingStep.outbuildingNumber,
    );
    const previousOutbuildingNumber = outbuildingNumbers[currentOutbuildingNumberIndex - 1];

    setAutoNavigateToOutbuildingNumber(previousOutbuildingNumber);
  };

  const goToNextStructure = () => {
    if (isLastOutbuilding) return;

    const currentOutbuildingNumberIndex = outbuildingNumbers.findIndex(
      ob => ob === currentOutbuildingStep.outbuildingNumber,
    );
    const nextOutbuildingNumber = outbuildingNumbers[currentOutbuildingNumberIndex + 1];

    setAutoNavigateToOutbuildingNumber(nextOutbuildingNumber);
  };

  const handleSelectOutbuilding = opt => {
    const outbuildingNumber = opt?.value;

    const outbuildingStepIndex = outbuildingSteps.findIndex(ob => ob.outbuildingNumber === outbuildingNumber);

    setCurrentOutbuildingStepIndex(outbuildingStepIndex);
  };
  // #endregion FUNCTIONS

  // #region EFFECTS
  useEffect(() => {
    if (isActive) {
      setShowReview(true);
    }
  }, [isActive]);

  useEffect(() => {
    // this will handle when the user deletes the last structure and we need to show the review screen again
    if (isActive && !outbuildingNumbers.length && !showReview) {
      setShowReview(true);
    }
  }, [isActive, outbuildingNumbers.length]);

  useEffect(() => {
    if (autoNavigateToOutbuildingNumber === -1) {
      return;
    }

    const nextOutbuildingStepIndex = outbuildingSteps.findIndex(
      ob => ob.outbuildingNumber === autoNavigateToOutbuildingNumber,
    );

    setCurrentOutbuildingStepIndex(nextOutbuildingStepIndex);
    setShowConfirmOutbuildingRemoval(false);
    setAutoNavigateToOutbuildingNumber(-1);
  }, [autoNavigateToOutbuildingNumber]);

  // #endregion EFFECTS

  if (showReview) {
    return (
      <FarmOutbuildingsReview
        //
        classes={classes}
        BOTTOM_PANEL_TRANSITION={BOTTOM_PANEL_TRANSITION}
        selfInspectIntro={selfInspectIntro}
        hideBackButton={hideBackButton}
        goBack={goBackOverride}
        handleAdditionalStructureNo={handleAdditionalStructureNo}
        addingOutbuilding={addingOutbuilding}
        handleAdditionalStructureYes={handleAdditionalStructureYes}
        outbuildingSteps={outbuildingSteps}
        viewOutbuilding={viewOutbuilding}
        showNoOutbuildingsError={showNoOutbuildingsError}
      />
    );
  }

  return (
    <>
      <div className={classes.container}>
        <div className={classes.container}>
          <div
            style={{
              maxHeight: '100vh',
              transition: BOTTOM_PANEL_TRANSITION,
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                fontSize: 'initial',
                color: 'white',
              }}
            >
              <div className="flex-1 row-start-center">
                <div
                  style={{
                    color: 'var(--jmi-red)',
                    visibility: showAdditionalStructuresQuestion ? 'hidden' : 'visible',
                  }}
                >
                  {removingOutbuilding ? (
                    <Loading size={20} color="var(--jmi-red)" />
                  ) : (
                    <DeleteIcon
                      onClick={evt => {
                        setShowConfirmOutbuildingRemoval(true);
                      }}
                    />
                  )}
                </div>
              </div>

              <div className="flex-">
                <SelfInspectQuestionLabel style={{ color: 'white' }}>
                  Structure {currentOutbuildingIndex + 1} of {outbuildingNumbers.length}
                </SelfInspectQuestionLabel>
              </div>

              <div className="flex-1 row-end-center">
                <SelfInspectButton
                  style={{
                    fontSize: 12,
                    color: 'white',
                    backgroundColor: '#fff2',
                  }}
                  label="Overview"
                  onClick={handleGoToReview}
                />
              </div>
            </div>
          </div>

          <hr
            style={{
              width: '100%',
              borderStyle: 'solid',
              borderColor: '#0001',
              borderRadius: 2,
            }}
          />

          {InputComponent && currentOutbuildingStep && (
            <InputComponent
              //
              // debug
              {...props}
              {...currentOutbuildingStep}
              goBack={goBackOverride}
              updateAnswer={updateAnswerOverride}
              confirmAnswer={confirmAnswerOverride}
              deleteImage={deleteImageOverride}
            />
          )}

          {!!questionLabel3 && (
            <div className={classes.supportNumber}>
              <div className={classes.questionLabel3}>{questionLabel3}</div>
            </div>
          )}
        </div>
      </div>

      <Dialog
        open={!!showConfirmOutbuildingRemoval}
        maxWidth="lg"
        onClose={cancelRemoveOutbuilding}
        aria-labelledby="image-modal-title"
        // className={classes.imageModal}
        autoScrollBodyContent={false}
        contentStyle={{ width: '100%', maxWidth: 'none' }}
      >
        <DialogContent className="col-center-center">
          <h3 style={{ textAlign: 'center' }}>Please confirm that you want to remove this structure</h3>
          <div
            className="row-center-center"
            style={{
              marginTop: 25,
              marginBottom: 5,
            }}
          >
            <MuiButton className="red-button" style={{ marginRight: 10 }} onClick={confirmRemoveOutbuilding}>
              Confirm Removal
            </MuiButton>

            <MuiButton className="blue-button" style={{ marginLeft: 10 }} onClick={cancelRemoveOutbuilding}>
              Close
            </MuiButton>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
});

FarmOutbuildingsCard.propTypes = {};
FarmOutbuildingsCard.defaultProps = {};

export default FarmOutbuildingsCard;
